import { createClient, type SupabaseClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL?.trim() ?? ''
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY?.trim() ?? ''

export const supabaseConfigError =
  !supabaseUrl || !supabaseAnonKey
    ? import.meta.env.PROD
      ? 'Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY in this deployment. These must be set in Cloudflare Pages → Settings → Environment variables (Production and Preview), then the site must be rebuilt.'
      : 'Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY. Add them to .env.local in the project root, then restart npm run dev.'
    : null

export const supabase: SupabaseClient = supabaseConfigError
  ? (undefined as unknown as SupabaseClient)
  : createClient(supabaseUrl, supabaseAnonKey)
